// `aboutText` is plain text, so its `\n` breaks carry the paragraphs.
export function splitAboutTextParagraphs(aboutText: string): string[] {
  return aboutText.split('\n')
}
